import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'

const DialogLookup = (props) => {
  const [selection, setSelection] = useState([])
  const { 
    Component, 
    title,
    size,
    isOpen, 
    setIsOpen,
    setLookupField,
    lookupFilter,
    withSelect,
    telespectadoresApp,
  } = props

  const handleClose = () => {
    setIsOpen(false)
  }

  const handlePopulateLookupField = (row) => {
    setLookupField(row)
    handleClose()
  }

  const handleSelection = () => {
    setLookupField(selection)
    handleClose()
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth={size}
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="dialog-capa"
    >
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent style={{ backgroundColor: '#eee' }}>
        {<Component 
          populateLookupField={handlePopulateLookupField}
          lookupFilter={lookupFilter}
          withSelect={withSelect}
          setSelection={setSelection}
          telespectadoresApp={telespectadoresApp}
        />}
      </DialogContent>
      <DialogActions>
        <Button color='secondary' onClick={handleClose}>Fechar</Button>
        {withSelect && 
        <Button color='primary' onClick={handleSelection}>Selecionar</Button>
        }
      </DialogActions>
    </Dialog> 
  )
}

export default DialogLookup